export enum EventFields {
  DRIVER_BEHAVIOR = 'driver-behavior',
  MEDIA = 'media',
  SAFETY_INCIDENT = 'safety-incidents',
  TRACKING = 'tracking',
  OTHER = 'other',
}
